<template>
  <el-dialog
    :title="`出库明细(${outInfo.code})`"
    :visible.sync="visible"
    width="600px"
    append-to-body
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      :data="outInfo.detailList">
      <el-table-column
        label="商品名称"
        prop="skuName"></el-table-column>
      <el-table-column
        label="出库数量"
        width="100"
        prop="num"></el-table-column>
      <el-table-column
        label="实际出库数量"
        width="100"
        prop="realNum"></el-table-column>
    </el-table>
    <div slot="footer">
      <!-- <el-button
        type="primary"
        @click="addItem">新增</el-button> -->
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
// import CateEditModal from './cate-edit-modal.vue'

export default {
  name: 'DetailModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      outInfo: {},
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        outOrderId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {
        pageNum: 1,
        pageSize: 10,
        outOrderId: null
      }
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/outdetail', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          this.outInfo = res.data.data
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.config.outOrderId = row.id
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
